import { formatTooltipValue } from '@/helpers/formatters';

const getUndefinedValue = (context) => {
  const { datasets } = context.chart.data;
  const declinedIndex = datasets.findIndex((dataset) => dataset.label === 'Declined');
  const undefinedValue = context.dataset.value + (datasets?.[declinedIndex]?.value || 0);

  return undefinedValue;
};

export const datalabelsConfig = (textDarkest, white, suggestedMax, fontSize = '11px') => ({
  color: function colorCallback(context) {
    const max = suggestedMax.value;
    let value = context.dataset.data[context.dataIndex];

    if (context.dataset.label === 'Not Submitted') {
      value = getUndefinedValue(context);
    }

    const percentOfSpace = (value / max) * 100;

    if (!value) return 'transparent';

    return percentOfSpace < 20 ? textDarkest.value : white.value;
  },
  anchor: 'end',
  font: {
    size: fontSize,
    weight: '500',
  },
  align: function alignCallback(context) {
    const max = suggestedMax.value;
    let value = context.dataset.data[context.dataIndex];

    if (context.dataset.label === 'Not Submitted') {
      value = getUndefinedValue(context);
    }

    const percentOfSpace = (value / max) * 100;

    if (Number.isNaN(percentOfSpace)) return 'end';

    return percentOfSpace < 20 ? 'end' : 'start';
  },
  formatter: function formatterCallback(value, context) {
    const { dataset } = context;

    if (Number.isNaN(value) || !value || dataset.label === 'Declined') return '';

    if (dataset.label === 'Not Submitted') {
      return formatTooltipValue(getUndefinedValue(context), 'percent');
    }

    return formatTooltipValue(value, 'percent');
  },
});
